import React, { useEffect, useRef, useState } from 'react';
import '../../Static/Master/PackPrintStruct.css';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useMediaQuery, Button } from '@mui/material';
import ReactToPrint from 'react-to-print';
import { Grid, Paper } from '@mui/material';
import { fetchAdminSaleData } from '../../Store/PHPSlice/stockApi';
import { selectAdminSaleData, selectStkInwdata } from '../Selectors/Master/OutwardSelectors';
import { fetchCompanyData } from '../../Store/PHPSlice/Firm';
import { selectFirm } from '../Selectors/Master/ItemSelectors';
import { fetchStkInwData, updateMainStkInw } from '../../Store/PHPSlice/StkInw';


const StkInwEdit = () => {
    const { Id } = useParams();
    const dispatch = useDispatch();
    const componentRef = useRef();
    const [selectedIds, setSelectedIds] = useState([]);
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const [formData, setFormData] = useState({
        stkid: Id,
        ID: '',
        balamt: '',
        billNo: '',
        cgst: '',
        discnt_amt: '',
        discnt_type: '',
        discnt_val: '',
        dt: '',
        freight_ch: '',
        gst: '',
        gst_val: '',
        igst: '',
        netamt: '',
        other_ch: '',
        schlId: '',
        schlNm: '',
        sgst: '',
        totamt: '',
        totissqty: '',
        zoneId: '',
        zoneNm: '',
        firmId: '',
        firmNm: '',
        adrs: '',
        schladrs: "",
        firmph: '',
        fgst: '',
        schlph: '',
        totrate: '', //totprate
        totsrate: '',
        sgstper: '',
        cgstper: '',
        igstper: '',
        schlcd: '',
        fadrs: '',
        fph: '',
        bnkNm: '',
        brnchNm: '',
        ifsc: '',
        accno: '',
        p_ph: '',
        p_adrs: '',
        partyNm: '',
        userId: userdata?.ID
    });
    const [packInfo, setPackInfo] = useState([]);
    const [selectFirmdata, setSelectFirmdata] = useState({});
    const [deletedData, setDeletedData] = useState([]);

    const packData = useSelector(selectStkInwdata);
    const firmlist = useSelector(selectFirm);
    // console.log(packData)
    useEffect(() => {
        dispatch(fetchStkInwData({ id: Id }));
        dispatch(fetchCompanyData());
    }, [Id, dispatch]);

    useEffect(() => {
        if (packData?.data) {
            const item = packData?.data;
            const {
                ID,
                balamt,
                stkMemo,
                cgst,
                discnt_amt,
                discnt_type,
                discnt_val,
                dt,
                freight_ch,
                gst,
                gst_val,
                igst,
                netamt,
                other_ch,
                schlId,
                schlNm,
                sgst,
                totamt,
                totqty,
                zoneId,
                zoneNm,
                firmId,
                firmNm,
                fadrs,
                schladrs,
                fGST,
                fph,
                schlph,
                schlcd,
                bankNm,
                branchNm,
                ifsc,
                ac_no,
                p_ph,
                p_adrs,
                partyNm
            } = item;
            const firmdata = firmlist?.data?.find(item => item.ID === firmId);
            setSelectFirmdata(firmdata);
            const info = packData.info;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.prate), 0);
            const totsrate = info?.reduce((acc, sum) => acc + parseFloat(sum.srate), 0);
            let sgstper, igstper, cgstper;
            if (igst === '0') {
                sgstper = (parseFloat(gst_val) / 2);
                cgstper = (parseFloat(gst_val) / 2);
                igstper = 0;
            } else {
                igstper = gst;
                sgstper = 0;
                cgstper = 0;
            }
            setFormData(prev => ({
                ...prev,
                ID: ID,
                balamt: balamt,
                billNo: stkMemo,
                cgst: cgst,
                discnt_amt: discnt_amt,
                discnt_type: discnt_type,
                discnt_val: discnt_val,
                dt: dt,
                freight_ch: freight_ch,
                fgst: fGST,
                gst: gst,
                gst_val: gst_val,
                igst: igst,
                netamt: netamt,
                other_ch: other_ch,
                schlId: schlId,
                schlNm: schlNm,
                sgst: sgst,
                totamt: totamt,
                totsrate: totsrate,
                totissqty: totqty,
                zoneId: zoneId,
                zoneNm: zoneNm,
                firmId: firmId,
                firmNm: firmNm,
                fadrs: fadrs,
                schladrs: schladrs,
                schlph: schlph,
                fph: fph,
                totrate: totrate,
                igstper: igstper,
                sgstper: sgstper,
                cgstper: cgstper,
                schlcd: schlcd,
                bnkNm: bankNm,
                brnchNm: branchNm,
                ifsc: ifsc,
                accno: ac_no,
                p_adrs: p_adrs,
                p_ph: p_ph,
                partyNm: partyNm
            }));
        }
        if (packData?.info && packData.info?.length > 0) {
            const info = packData.info;
            const totrate = info?.reduce((acc, sum) => acc + parseFloat(sum.prate), 0);

            setPackInfo(info);
        }
    }, [packData]);


    function numberToWords(num) {
        const below20 = [
            'Zero', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
            'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
            'Eighteen', 'Nineteen'
        ];
        const tens = [
            '', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'
        ];
        const thousands = ['', 'Thousand', 'Million', 'Billion', 'Trillion'];

        if (num === 0) return below20[0];

        let words = '';

        let i = 0;
        while (num > 0) {
            if (num % 1000 !== 0) {
                words = helper(num % 1000) + (thousands[i] ? ' ' + thousands[i] : '') + ' ' + words;
            }
            num = Math.floor(num / 1000);
            i++;
        }

        return words.trim().toUpperCase();

        function helper(n) {
            if (n === 0) return '';
            if (n < 20) return below20[n];
            if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 !== 0 ? ' ' + below20[n % 10] : '');
            return below20[Math.floor(n / 100)] + ' Hundred' + (n % 100 !== 0 ? ' ' + helper(n % 100) : '');
        }
    }
    const handleCheckboxChange = async (checked, id) => {
        if (checked) {
            await setSelectedIds((prev) => [...prev, id]);
            // console.log(selectedIds);
        } else {
            await setSelectedIds((prev) => prev.filter((itemId) => itemId !== id));
            // console.log(selectedIds);
        }
        // console.log(selectedIds);
    };

    const handleSelectAll = async (e) => {
        if (e.target.checked) {
            // Select all item.IDs
            const allIds = packInfo.map((item) => item.ID);
            await setSelectedIds(allIds);
            // console.log(selectedIds);
        } else {
            // Deselect all
            await setSelectedIds([]);
            // console.log(selectedIds);
        }
    };

    const handleDelete = () => {
        if (selectedIds.length === 0) {
            alert("Please select at least one item to delete.");
            return;
        }
        if (window.confirm("Are you sure you want to delete the selected items?")) {
            // dispatch(deleteStkInw(selectedIds))
            //     .then(() => {
            //         // Handle successful deletion
            //         setSelectedIds([]);
            //     })
            //     .catch((error) => {
            //         // Handle error
            //         console.error("Error deleting items:", error);
            //     });
            alert("Selected items deleted successfully! (This is a placeholder action)");
        }
    };

    const handleDeleteSelected = () => {
        const updatedPackInfo = packInfo?.filter(item => !selectedIds.includes(item.ID));
        const deletedPackInfo = packInfo?.filter(item => selectedIds.includes(item.ID));
        setPackInfo(updatedPackInfo);
        setDeletedData(prev => [...prev, ...deletedPackInfo]);
        updateFormDataTotals(updatedPackInfo);
        setSelectedIds([]);

        // Optionally recalculate totals here if needed:
        // updateFormDataTotals(updatedPackInfo);
    };

    const updateFormDataTotals = (data) => {
        const totalQty = data.reduce((sum, item) => sum + Number(item.qty || 0), 0);
        const totalPrate = data.reduce((sum, item) => sum + Number(item.prate || 0), 0);
        const totalSrate = data.reduce((sum, item) => sum + Number(item.srate || 0), 0);
        const totalAmt = data.reduce((sum, item) => sum + Number(item.amt || 0), 0);

        const discnt_amt = Math.round((parseFloat(formData.discnt_val) / 100) * parseFloat(totalAmt));
        let gst_val = Math.round(totalAmt * (parseFloat(formData.gst_val) / 100));
        const netamt = parseFloat(totalAmt) + parseFloat(gst_val) + parseFloat(formData.other_ch) + parseFloat(formData.freight_ch) - parseFloat(discnt_amt);

        let igst = 0;
        let cgst = 0;
        let sgst = 0;
        if (formData?.igst !== '0') {
            igst = gst_val;
            cgst = 0;
            sgst = 0;
        } else {
            const halfgst = Math.round(parseFloat(gst_val) / 2).toFixed(2);

            cgst = halfgst;
            sgst = halfgst;
            igst = '0';
        }

        setFormData({
            ...formData,
            totissqty: totalQty,
            totrate: totalPrate,
            totsrate: totalSrate,
            totamt: totalAmt,
            igst: igst,
            cgst: cgst,
            sgst: sgst,
            netamt: netamt,
            discnt_amt: discnt_amt
        });
    };


    const handlePackInfoChange = (index, field, value) => {
        const updated = [...packInfo];

        updated[index] = { ...updated[index], [field]: value };


        if (field === "qty" || field === "prate") {
            const qty = parseFloat(updated[index].qty) || 0;
            const rate = parseFloat(updated[index].prate) || 0;
            updated[index].amt = parseInt(qty * rate);
        }

        // Recalculate totals
        const totissqty = updated.reduce((sum, item) => sum + (parseInt(item.qty) || 0), 0);
        const totrate = updated.reduce((sum, item) => sum + (parseInt(item.prate) || 0), 0);
        const totamt = updated.reduce((sum, item) => sum + (parseInt(item.amt) || 0), 0);

        // Calculate discount
        let discnt_amt = parseInt(formData.discnt_amt) || 0;
        if (formData.discnt_type === "%") {
            discnt_amt = parseInt(totamt * (parseFloat(formData.discnt_val) || 0) / 100).toFixed(2);
        }

        // GST calculation
        const cgst = parseInt(totamt * (parseFloat(formData.cgstper) || 0) / 100).toFixed(2);
        const sgst = parseInt(totamt * (parseFloat(formData.sgstper) || 0) / 100).toFixed(2);
        const igst = parseInt(totamt * (parseFloat(formData.igstper) || 0) / 100).toFixed(2);

        // Net amount
        const netamt = parseInt(
            totamt
            - parseFloat(discnt_amt)
            + parseFloat(cgst)
            + parseFloat(sgst)
            + parseFloat(igst)
            + parseFloat(formData.freight_ch || 0)
            + parseFloat(formData.other_ch || 0)
        ).toFixed(2);

        // Update state
        setPackInfo(updated);
        setFormData(prev => ({
            ...prev,
            totissqty,
            totrate: parseInt(totrate.toFixed(2)),
            totamt: parseInt(totamt.toFixed(2)),
            discnt_amt,
            cgst,
            sgst,
            igst,
            netamt
        }));
    };


    function postObj(packInfo, deletedData, formData) {
        const data = {
            packInfo: packInfo,
            deletedData: deletedData,
            totqty: formData.totissqty,
            totprate: formData.totrate,
            totsrate: formData.totsrate,
            totamt: formData.totamt,
            netamt: formData.netamt,
            igst: formData.igst,
            cgst: formData.cgst,
            sgst: formData.sgst,
            userId: formData.userId,
            stkId: formData.stkid,
            discnt_amt: formData.discnt_amt
        };
        return data;
    };

    const handleSubmit = (e) => {
        e.preventDefault();


        const finalObj = postObj(packInfo, deletedData, formData);
        // console.log(finalObj);

        dispatch(updateMainStkInw(finalObj))
            .unwrap()
            .then((result) => {
                // Handle success
                // console.log('POST request successful!', result);
                alert("Stock Inward Updated");
                window.close();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });

    };
    return (

        <Grid item xs={12}>
            <Paper>
                <div ref={componentRef} style={{ padding: '1%' }}>
                    {/* Heading */}
                    <h3 className="heading">Stock Inward View</h3>

                    {/* Upper part: Two tables side by side */}
                    <div className="flex-container">
                        {/* Left Table */}
                        <table>
                            <tbody>
                                <tr>
                                    <td><h2>{formData.firmNm}</h2>
                                        <b>Add.:</b>{formData.fadrs}
                                        <br />
                                        <b>Contact:</b>{formData.fph} <br />
                                        <b>GST No.:</b> {formData.fgst}
                                    </td>
                                </tr>
                                <tr>
                                    <td><h3>TO:</h3>
                                        <b>Party Name:</b><b style={{ color: 'blue' }}>{formData.partyNm} </b> <br />

                                        <b>Add:</b> <span style={{ color: 'blue' }}>{formData.p_adrs}</span>
                                        <br />
                                        <b>Contact:</b> <span style={{ color: 'blue' }}>{formData.p_ph}</span>
                                    </td>
                                </tr>

                            </tbody>
                        </table>

                        {/* Right Table */}
                        <table>

                            <tbody>

                                <tr>
                                    <td>Bill No:</td>
                                    <td><b>{formData.billNo}</b></td>
                                </tr>
                                <tr>
                                    <td>Date:</td>
                                    <td>{formData.dt}</td>
                                </tr>
                                <tr>
                                    <td>Transport:</td>
                                    <td>{formData.trspt}</td>
                                </tr>
                                <tr>
                                    <td>Remark:</td>
                                    <td>{formData.remark}</td>
                                </tr>
                                {/* <tr>
                                    <td>No. of Cartoons:</td>
                                    <td>{formData.parcelqty}</td>
                                </tr> */}
                                <tr>
                                    <td>Ship To:</td>
                                    <td>{formData.shtoNm}</td>
                                </tr>
                                <tr>
                                    <td>Ship Address:</td>
                                    <td>{formData.shtoadrs}</td>
                                </tr>

                            </tbody>
                        </table>
                    </div>
                    <Grid container alignItems="center" justifyContent="space-between" spacing={2}>

                        <Grid item xs={12} sm={2} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <div style={{ textAlign: 'right', margin: '10px 0' }}>
                                <Button variant="contained" color="primary" onClick={handleDeleteSelected}>
                                    Delete
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                    {/* Main Table */}
                    {packInfo.length > 0 &&

                        <table className="main-table">
                            <thead>
                                <tr>
                                    <th>
                                        <input
                                            type="checkbox"
                                            checked={packInfo.length > 0 && selectedIds.length === packInfo.length}
                                            onChange={handleSelectAll}
                                        />
                                    </th>
                                    <th>SR NO.</th>
                                    <th>PARTICULARS</th>
                                    <th>SIZE</th>
                                    <th>QTY</th>
                                    <th>PURCHASE RATE</th>
                                    <th>SALE RATE</th>
                                    <th>AMOUNT</th>
                                </tr>
                            </thead>
                            <tbody>
                                {packInfo.map((item, index) => (
                                    <tr key={index}>
                                        <td><input
                                            type='checkbox'
                                            checked={selectedIds.includes(item.ID)}
                                            onChange={(e) => handleCheckboxChange(e.target.checked, item.ID)}
                                        ></input></td>
                                        <td>{index + 1}</td>
                                        <td>{item.itemNm}</td>
                                        <td>{item.size}</td>

                                        <td >
                                            <input
                                                style={{ width: '60px' }}
                                                type="text"
                                                value={item.qty}
                                                onChange={(e) => handlePackInfoChange(index, "qty", e.target.value)}
                                            /></td>
                                        <td >
                                            <input
                                                style={{ width: '60px' }}
                                                type="text"
                                                value={item.prate}
                                                onChange={(e) => handlePackInfoChange(index, "prate", e.target.value)}
                                            />
                                        </td>
                                        <td> {/* ✅ S RATE input */}
                                            <input
                                                style={{ width: '60px' }}
                                                type="text"
                                                value={item.srate || ""}
                                                onChange={(e) => handlePackInfoChange(index, "srate", e.target.value)}
                                            />
                                        </td>

                                        <td>{item.amt}</td>
                                    </tr>
                                ))}
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td><b>Total</b></td>
                                    <td><b>{formData.totissqty}</b></td>
                                    <td><b>{formData.totrate}</b></td>
                                    <td><b>{formData.totsrate}</b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                            </tbody>
                        </table>
                    }

                    {/* Footer */}
                    <div className="flex-container">
                        <table>
                            <tbody>
                                <tr>
                                    <td>AMOUNT IN WORDS:
                                        <b>{numberToWords(parseFloat(formData.totamt))}</b>
                                    </td>


                                </tr>
                                <tr>
                                    <td>TOTAL QTY: <b> {formData.totissqty}</b></td>
                                </tr>


                                <tr>
                                    <td>Bank Name: <b> {formData.bnkNm}</b></td>



                                </tr>
                                <tr>
                                    <td>Account No.: <b> {formData.accno}</b></td>
                                </tr>

                                <tr>
                                    <td>IFSC code: <b> {formData.ifsc}</b></td>
                                </tr>

                                <tr>
                                    <td>Branch Name: <b> {formData.brnchNm}</b></td>
                                </tr>

                            </tbody>
                        </table>

                        <table>

                            <tbody>

                                <tr>
                                    <td><b>SUB TOTAL :</b></td>
                                    <td><b>{formData.totamt}</b></td>
                                </tr>
                                <tr>
                                    <td><b>DISCOUNT AMOUNT ({formData.discnt_val}{formData.discnt_type}) :</b></td>
                                    <td><b>{formData.discnt_amt}</b></td>
                                </tr>
                                <tr>

                                    <td><b>CGST({formData.cgstper}%)</b></td>
                                    <td>
                                        <b>{formData.cgst}</b>
                                    </td>
                                </tr>
                                <tr>

                                    <td><b>SGST({formData.sgstper}%)</b></td>
                                    <td>
                                        <b>{formData.sgst}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b>IGST({formData.igstper}%)</b></td>
                                    <td>
                                        <b>{formData.igst}</b>
                                    </td>
                                </tr>


                                <tr>

                                    <td><b style={{ color: 'red' }}>FREIGHT</b></td>
                                    <td>
                                        <b style={{ color: 'red' }}>{formData.freight_ch}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b>OTHERS</b></td>
                                    <td>
                                        <b>{formData.other_ch}</b>
                                    </td>
                                </tr>

                                <tr>

                                    <td><b style={{ color: 'blue' }}>GRAND TOTAL</b></td>
                                    <td>
                                        <b style={{ color: 'blue' }}>{formData.netamt}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <Grid item xs={12} textAlign="center">
                        <Button variant="contained" color="primary" onClick={handleSubmit}>Update</Button>

                    </Grid>
                </div>

                {/* <div style={{ margin: '2% 5%' }}>
                    <ReactToPrint
                        trigger={() => <Button variant="contained" color="primary">Print</Button>}
                        content={() => componentRef.current}
                    />
                </div> */}
            </Paper>
        </Grid>
    );
};

export default StkInwEdit;
